// Sunday worship sets and the sermon playlist.

export const WORSHIP = {
  playlists:[
    {
      title:"Sunday Worship Sets",
      desc:"What we're singing in the room right now.",
      listId:"REPLACE_ME"
    }
  ]
};

// YouTube uploads-playlist id for the sermon archive.
export const SERMON_PLAYLIST_ID = "UUkyPmSLkKDblKDstvfFilsg";
